<template>
  <div :class="{'show':show}" class="header-search">
    <a class="search" @click.stop="click">_</a>
    <el-select
      ref="headerSearchSelect"
      v-model="search"
      :remote-method="querySearch"
      filterable
      default-first-option
      remote
      :placeholder="$t('common.search')"
      class="header-search-select"
      @change="change"
    >
      <el-option v-for="item in options" :key="item.id" :value="item" :label="'#' + getTicketId(item) + ' ' + item.customer.firstName + ' (' + item.customer.phone + ')'" />
    </el-select>
  </div>
</template>

<script>
// fuse is a lightweight fuzzy-search module
// make search results more in line with expectations
import Fuse from 'fuse.js';
import path from 'path';
import IssueService from '@/services/issue.service';
// import { EventBus } from '@/utils/event.bus.js';
import { getTicketId } from '@/utils/page-utils';

export default {
    name: 'HeaderSearch',
    data() {
        return {
            search: '',
            options: [],
            searchPool: [],
            // following should start with false, but, lack of UI.
            show: true,
            fuse: null
        };
    },
    computed: {
        technicians() {
            return this.$store.state.technicians.technicians;
        },
        currentUser() {
            return this.$store.state.auth.user;
        },
        superUser() {
            return this.currentUser && (this.currentUser.roles.includes('ROLE_ADMIN') || this.currentUser.roles.includes('ROLE_MODERATOR'));
        },
        customerUser() {
            return !this.superUser && this.currentUser && !this.currentUser.roles.includes('ROLE_TECHNICIAN') && this.currentUser.roles.includes('ROLE_CUSTOMER');
        },
        routes() {
            return this.$store.getters.permissionRoutes;
        }
    },
    watch: {
        routes() {
            this.searchPool = this.generateRoutes(this.routes);
        },
        searchPool(list) {
            this.initFuse(list);
        },
        show(value) {
            if (value) {
                document.body.addEventListener('click', this.close);
            } else {
                document.body.removeEventListener('click', this.close);
            }
        }
    },
    mounted() {
        this.searchPool = this.generateRoutes(this.routes);
    },
    methods: {
        getTicketId,
        click() {
            this.show = !this.show;
            if (this.show) {
                this.$refs.headerSearchSelect && this.$refs.headerSearchSelect.focus();
            }
        },
        close() {
            this.$refs.headerSearchSelect && this.$refs.headerSearchSelect.blur();
            this.options = [];
            this.show = false;
        },
        change(val) {
            const self = this;
            if (parseInt(val)) {

            } else {
                // not a number, then an issue should be.
                // EventBus.$emit('internalSearch', val);
                // this.$router.push({
                //     name: 'tickets',
                //     params: { issue: val }
                // }).catch(error => {
                //     if (error.name === 'NavigationDuplicated') {
                //         // implement an internal way to refresh view.
                //         // EventBus.$emit('internalSearch', val); will do it anyways.
                //     } else {
                //         throw error;
                //     }
                // });
                // EventBus.$emit('internalSearch', val);
                IssueService.getData(val.id).then(
                    response => {
                        self.$router.push({
                            name: 'aticket',
                            query: { ticketId: val.id },
                            params: {
                                issue: response.data,
                                technicians: self.technicians,
                                isCustomer: self.customerUser,
                                superUser: self.superUser
                            }
                        });
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                  error.message || error.toString());
                    }
                );

                // sadly... I have to emit always, not good, nope...
            }
            this.search = '';
            this.options = [];
            // should have an icon to show and hide, if I do the following I need UI.
            // this.$nextTick(() => {
            //     this.show = false;
            // });
        },
        initFuse(list) {
            this.fuse = new Fuse(list, {
                shouldSort: true,
                threshold: 0.4,
                location: 0,
                distance: 100,
                maxPatternLength: 32,
                minMatchCharLength: 1,
                keys: [{
                    name: 'title',
                    weight: 0.7
                }, {
                    name: 'path',
                    weight: 0.3
                }]
            });
        },
        // Filter out the routes that can be displayed in the sidebar
        // And generate the internationalized title
        generateRoutes(routes, basePath = '/', prefixTitle = []) {
            let res = [];

            for (const router of routes) {
                // skip hidden router
                if (router.hidden) {
                    // eslint-disable-next-line
                    continue;
                }

                const data = {
                    path: path.resolve(basePath, router.path),
                    title: [...prefixTitle]
                };

                if (router.meta && router.meta.title) {
                    data.title = [...data.title, router.meta.title];

                    if (router.redirect !== 'noRedirect') {
                        // only push the routes with title
                        // special case: need to exclude parent router without redirect
                        res.push(data);
                    }
                }

                // recursive child routes
                if (router.children) {
                    const tempRoutes = this.generateRoutes(router.children, data.path, data.title);
                    if (tempRoutes.length >= 1) {
                        res = [...res, ...tempRoutes];
                    }
                }
            }
            return res;
        },
        querySearch(query) {
            if (query !== '' && parseInt(query) || query.length > 3) {
                IssueService.searchIssues(query).then(
                    response => {
                        this.options = response.data;
                        // buscar en todos.

                        // this.foundQty = this.issuesFound.length;
                        // this.processing = false;
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                  error.message || error.toString());
                    }
                );
                // this.options = this.fuse.search(query);
            } else {
                this.options = [];
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.header-search {
  font-size: 0 !important;

  .search{
    width: 25px;
    height: 25px;
    background-color: red;
  }

  .header-search-select {
    font-size: 18px;
    transition: width 0.2s;
    width: 0;
    overflow: hidden;
    background: transparent;
    border-radius: 0;
    display: inline-block;
    vertical-align: middle;

    /deep/ .el-input__inner {
      border-radius: 0;
      border: 0;
      padding-left: 0;
      padding-right: 0;
      box-shadow: none !important;
      border-bottom: 1px solid #d9d9d9;
      vertical-align: middle;
    }
  }

  &.show {
    .header-search-select {
        @media(max-width: 450px) {
            width: 130px;
            margin: 0;
        }
        width: 210px;
        margin-left: 10px;
    }
  }
}
</style>
